import { render, staticRenderFns } from "./rpt-thirty-cases.vue?vue&type=template&id=128697c0&"
import script from "./rpt-thirty-cases.js?vue&type=script&lang=js&"
export * from "./rpt-thirty-cases.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports